var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['position-btn', _vm.this_isLocation ? 'on' : ''],on:{"click":function($event){return _vm.onOff()}}})}
var staticRenderFns = []

export { render, staticRenderFns }